module.exports = __webpack_public_path__ + "img/topicIcon.03b11cf5.png";